var webSocketServer = {
    data() {
        return {
            webSocketServer: null,
            defaultUrlWebSocketServer: 'ws://localhost:8005',
            successFullConnectionWebSocketServer: false,
            listPrinterWebSocketServer: [],
            indexSelectedPrinterWebSocketServer: -1,
            quantity: 1
        }
    },
    computed: {
    },
    filters: {
    },
    methods: {
        analyzeMessageWebSocketServer(data) {
            switch (data.cmd) {
                case 'obtenerImpresoras':
                    this.indexSelectedPrinterWebSocketServer = -1
                    this.listPrinterWebSocketServer = data.listaImpresoras
                    this.listPrinterWebSocketServer.forEach((element, index) => {
                        if (element == localStorage.printerWebSocketServer) {
                            this.indexSelectedPrinterWebSocketServer = index
                        }
                    });
                    if (this.indexSelectedPrinterWebSocketServer == -1) {
                        localStorage.removeItem('printerWebSocketServer')
                    }
                    break;
                case 'imprimirEtiqueta':
                    console.log(data.message)
                    break;
                default:
                    console.info('analyzeMessageWebSocketServer - Mensaje no codificado')
                    break;
            }
        },
        changeSelectedPrinterWebSocketServer() {
            localStorage.printerWebSocketServer = this.listPrinterWebSocketServer[this.indexSelectedPrinterWebSocketServer]
        },
        connectWebSocketServer(defaultUrl = null) {
            if (!this.successFullConnectionWebSocketServer) {
                this.defaultUrlWebSocketServer = (defaultUrl != null) ? defaultUrl : this.defaultUrlWebSocketServer
                try {
                    this.webSocketServer = new WebSocket('ws://localhost:8888');

                    this.webSocketServer.onopen = () => {
                        console.info('WebSocket Server conectado!!!')
                        this.successFullConnectionWebSocketServer = true
                        this.getPrinterWebSocketServer()
                    }

                    this.webSocketServer.onclose = () => {
                        console.info('Conexion WebSocket Server cerrada');
                        this.successFullConnectionWebSocketServer = false
                    }

                    this.webSocketServer.onmessage = (msg) => {
                        let data = JSON.parse(msg.data)
                        this.analyzeMessageWebSocketServer(data);
                    }

                } catch (exception) {
                    console.info('ERROR: ' + exception);
                }
            }
        },
        getPrinterWebSocketServer() {
            try {
                if (this.webSocketServer.readyState === 3) {
                } else {
                    let cmd = 'obtenerImpresoras'
                    this.webSocketServer.send(cmd + '|');
                }
            } catch (exception) {
                console.info('getPrinterWebSocketServer - ERROR: ' + exception);
            }
        },
        initMixinWebSocketServer() {
            this.connectWebSocketServer()
        },
        messageErrorConetionProgramWebSocketServer() {
            let mensaje = 'No hay conexión con la aplicación de WebSocketServer'
            console.log(mensaje)
            alert(mensaje)
        },
        printWebSocketServer(zpl, printer) {
            if (printer != undefined) {
                try {
                    if (this.webSocketServer.readyState === 3) {
                        messageErrorConetionProgramWebSocketServer()
                    } else {
                        for (let i = 0; i < this.quantity; i++) {
                            let cmd = 'imprimirEtiqueta';
                            this.webSocketServer.send(cmd + '|' + printer + '|' + zpl);
                            console.info('printWebSocketServer - Etiqueta enviada a la impresora ' + printer);
                        }
                    }
                } catch (exception) {
                    console.info('printWebSocketServer - ERROR: ' + exception);
                }
            } else {
                alert('No hay una impresora seleccionada para las etiquetas')
                this.$refs.openModalSetingModule.click()
            }
        },
        toPrintWebSocketServer(zpl) {
            this.printWebSocketServer(zpl, localStorage.printerWebSocketServer)
        }
    },
    mounted() {
        this.initMixinWebSocketServer();
    },
};

export default webSocketServer;